import {createModel} from "@rematch/core";

const alert = createModel({
  state: {
    type: "",
    delay: 3000,
    messages: []
  },
  reducers: {
    showAlert: (state: any, type: any, message: any) => ({
      ...state,
      type,
      delay: type === "error" ? 7000 : (message.length ? (message.length * 3 / 60) * 1000 : 3000),
      messages: [
        ...state.messages,
        {
          message,
          type
        }
      ]
    }),
    closeAlert: (state: any, message: any) => {
      let newMessages = [...state.messages];

      let targetIndex = state.messages.findIndex((m: any) => message === m);
      if (targetIndex > -1) {
        newMessages.splice(targetIndex, 1);
      }

      return {
        ...state,
        messages: newMessages
      };
    }
  }
});

export default alert;
